<template>
  <div class="shell-el">
    <Logo
      class="logo-el md-under-d-none"
      :logo-url="logoUrl"
    />
    <div class="login-left md-under-d-none"
         :style="{backgroundImage: `url(${backgroundImage})`}"
    >
    </div>
    <div class="login-right"
      :class="{'general': $route.name !== 'register'}"
    >
      <VuePerfectScrollbar
        class="scroll-VuePerfectScrollbar pt-4 pb-6"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="i18-outer">
          <Logo
            class="mobile-logo ml-6"
            :logo-url="logoUrl"
          />
          <i18n class="mr-6 i18n-component"></i18n>
        </div>
        <div class="right-real-content">
          <slot class=""></slot>
        </div>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import i18n from "@/layouts/components/navbar/components/I18n.vue"
import Logo from '@/layouts/components/Logo'
import defaultBgImage from '@/assets/images/loginbg.png'
import logoUrl from '../../assets/images/logo/logo.png'
export default {
  name: "fullPageShell",
  data() {
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      backgroundImage: defaultBgImage,
      logoUrl: logoUrl,
    }
  },
  components: {
    Logo,
    i18n,
    VuePerfectScrollbar,
  },
  methods: {
    resetPasswordHandle() {
      this.$router.push({name: 'resetPassword'});
    },
  }
}
</script>

<style scoped lang="scss">

.shell-el {
  height: 100%;
  overflow-y: hidden;
  .login-left {
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .vs-row-shell,
  .vs-col-col {
    height: 100%;
  }
  .vs-row-shell {
    width: 100%;
  }
}



.i18n-outer {
  display: flex;
  justify-content: flex-end;
}
.login-right {
  .right-real-content {
    padding: 0 3rem;
    padding-top: 3rem;
  }
  .i18n-component {
    float: right;
  }
  &.general {
    .i18n-component {
      float: right;
    }
  }
  .scroll-VuePerfectScrollbar {
    height: 100%;
  }

  .mobile-logo {

  }
}

</style>
<style lang="scss">
@media screen and (min-width: 768px) {
  .shell-el {
    .logo-el {
      position: fixed;
      top: 20px;
      left: 20px;
      z-index: 99;
    }
  }
  .login-right {
    &.general {
      .i18n-component {
        float: right;
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 99;
      }
    }
  }
}
@media screen and (min-width: 1200px){
  .shell-el {
    padding-right: 33.3%;
  }
  .login-right {
    background-color: #ffffff;
    position: absolute;
    top: 0;
    right: 0;
    width: 33.3%;
    height: 100%;
  }
}

@media screen and (min-width: 1200px) {
  .shell-el {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}

.shell-el {
  background-color: #ffffff;
}
.login-right {
  background-color: #ffffff;
}

@media screen and (max-width: 768px){
  .login-right {
    height: 100%;

    .i18-outer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .simpleRegister {
    #zsiq_float{
      display: none;
    }
  }
  .simpleview {
    .site-info{
      display: none;
    }
    .i18-outer {
      display: none;
    }
    .logo-el{
      display: none;
    }
    .center{
      display: none;
    }
  }
}
</style>

